import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { ExportTaskResponse, ExportTaskCreateRequest, ExportTaskUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { EnumToComboValues, GridColumnHelper } from '../utils';
import { ExportTaskDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { ExportTaskSettingsSectionHandler } from './settings.section';

@RegisterEntityHandler('exporttask')
@Injectable()
export class ExportTaskHandler extends EntityHandler<ExportTaskResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['active', 'suspended', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listExportTasks/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listExportTasks(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'exporttask',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.EXPORTTASKS'),
        }));
    }

    getEntity(id: string): Promise<ExportTaskResponse> {
        return this.admin.getCached(`getExportTask/${id}`, api => api.entities.getExportTask(id), 10);
    }

    createEntity(ownerId: string, entity: ExportTaskCreateRequest): Promise<ExportTaskResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createExportTask(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateExportTask(entity.id, { state: state as any }));
    }

    async getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.EXPORTTASK.COLUMNS');

        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.exporttask),
            grid.ComboColumn('deliveryMethod', 'MODE', EnumToComboValues(this.admin.i18n, 'ADMIN.EDITORS.EXPORTTASK.MODES', ['ftp', 'stream', 'http', 'firehose'], []), 80),
            grid.IdNameTextColumn('client', 'CLIENT', 120),
            grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
        ];
        columns.push(grid.TimeAgoColumn('modifiedDate', 'MODIFIED'));
        return columns;


    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<ExportTaskResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new ExportTaskDetailsSectionHandler(this.admin, ownerId, false),
                new ExportTaskSettingsSectionHandler(this.admin, ownerId, false),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: ExportTaskUpdateRequest, sections: FormSectionHandler<ExportTaskResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'exporttask',
            entity: {},
            sections: [
                new ExportTaskDetailsSectionHandler(this.admin, ownerId, true),
                new ExportTaskSettingsSectionHandler(this.admin, ownerId, true),
            ],
        });
    }

}













